import { cn } from "@patient-watch/ui";
import type { MaybeStringT } from "@patient-watch/types";

interface Props {
    icon: React.ReactNode;
    words: React.ReactNode | MaybeStringT;
    className?: string;
}

const IconDetail = ({ icon, words, className }: Props) => {
    return (
        <div
            className={cn(
                "flex items-center gap-x-2 gap-y-1 w-fit text-slate-800 dark:text-slate-200 text-sm",
                className
            )}
            style={{ flexWrap: "nowrap" }}
        >
            <span className="flex flex-shrink-0 justify-center items-center mx-auto my-auto [&_svg]:w-5 [&_svg]:h-5">
                {icon}
            </span>
            <span className="flex flex-grow my-auto">{words ?? ""}</span>
        </div>
    );
};

export default IconDetail;
